import React from 'react';
import { Box } from '@mui/material';
import DashboardLayout from '../../components/Dashboard/DashboardLayout';

const DashboardPage = () => {
  // Scroll to top on component mount
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ py: 1 }}>
      <DashboardLayout />
    </Box>
  );
};

export default DashboardPage;
